import { WebSocketMessageTypeIncoming } from "../../Enums/WebSocketMessageTypeIncoming";

export class MessageWebSocket{
    public Type?: WebSocketMessageTypeIncoming;
    public SessionId?: string;

    constructor(){

    }
}